import React, { useEffect } from 'react'

export default function DispatchArea(props) {
    const {
        selectedAreas,
        area,
        setSelectedAreas
    } = props;

    const formatPolicyAndUniqueIDs = (input) => {
    if (input.includes("Policy ID") && input.includes("Unique ID")) {
      return input.split(',')
                  .map(part => part.trim())
                  .join('\n');
    }
 
    return input;
   }

    const handleAreaCheck = (area, isChecked) => {
        if (isChecked) {
          setSelectedAreas(prevAreas => [...prevAreas, area]);
        } else {
          setSelectedAreas(prevAreas =>
            prevAreas.filter(item => item.id !== area.id)
          );
        }
    };

    return (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.6rem', justifyContent: 'flex-start', background: 'white', padding: '0.7rem', borderRadius: 10, marginBottom: '0.5rem' }}>
           <input
              type="checkbox"
              checked={selectedAreas.some(selected => selected.id === area.id)}
              onChange={e => handleAreaCheck(area, e.target.checked)}
            />
           <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: '0.3rem' }}>
                <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'black' }}>{area.name}</div>
                <div style={{ fontSize: '0.8rem', color: 'black' }}>{area.description ? formatPolicyAndUniqueIDs(area.description) : 'Description Not Available'}</div>
           </div>
        </div>
    )
}
